<div class="layout-ParentDiv innerDiv">
    <div class="layout-dashboard addPage">
        <div class="p-grid">
            <p-toast key="toastmsg" position="top-right"></p-toast>
            <div class="p-col-12 mainFormPadding">
                <div class="card ">
                    <form [formGroup]="academyMembershipForm" *ngIf="this.academyMembershipForm">
                        <div class="p-fluid p-formgrid p-grid m-0">
                            <div class="p-field p-col-12 div-border p-p-0">
                                <h3 class="head-page-title">
                                    {{pagetitle}}
                                </h3>
                            </div>
                        </div>
                        <div class="p-fluid p-formgrid p-grid">
                            <div class="p-field p-col-12 p-fluid p-formgrid p-grid mainFormGap">
                                <div class="p-field p-col-3 p-0 addFormDropDown">
                                    <div class="p-field p-col">
                                        <label for="membershipType">Membership type<span
                                                class="mandatory-feilds">*</span></label>
                                        <p-dropdown inputId="membershipType" [options]="membershipTypes"
                                            formControlName="membershipType" placeholder="Select membershipType"
                                            optionLabel="name" optionValue="value" (onChange)="onSelectAcademyMembershipType($event)"
                                            [ngClass]="{ 'is-invalid': submitted && f.membershipType.errors }"></p-dropdown>
                                        <div *ngIf="submitted && f.membershipType.errors" class="invalid-feedback">
                                            <div *ngIf="f.membershipType.errors.required">Please Select membership type
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-3 p-0 addFormDropDown">
                                    <div class="p-field p-col">
                                        <label for="sport">Sport type</label>
                                        <p-dropdown inputId="sport" [options]="sportTypeList" formControlName="sport"
                                            placeholder="Select Sport" optionLabel="name" optionValue="id" [showClear]="true"
                                            [ngClass]="{ 'is-invalid': submitted && f.sport.errors }"></p-dropdown>
                                        <div *ngIf="submitted && f.sport.errors" class="invalid-feedback">
                                            <div *ngIf="f.sport.errors.required">Please Select Sport</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-field p-col-3">
                                    <label for="planName">Plan Name<span class="mandatory-feilds">*</span></label>
                                    <input id="planName" formControlName="planName" type="text" pInputText
                                        autocomplete="off" [ngClass]="{ 'is-invalid': submitted && f.planName.errors }">
                                    <div *ngIf="((submitted && f.planName.errors) || (f.planName.errors && (f.planName.dirty || f.planName.touched)))"
                                        class="invalid-feedback">
                                        <div *ngIf="f.planName.errors.required">Plan Name is required</div>
                                    </div>
                                </div>
                                <div class="p-field p-col-3 p-0 addFormDropDown">
                                    <div class="p-field p-col">
                                        <label for="currency">Currency</label>
                                        <p-dropdown inputId="currency" [filter]="true" [options]="currencyList"
                                            formControlName="currency" placeholder=" Select" optionLabel="name"
                                            [ngClass]="{ 'is-invalid': submitted && f.currency.errors }">
                                        </p-dropdown>
                                        <div *ngIf="submitted && f.currency.errors" class="invalid-feedback">
                                            <div *ngIf="f.currency.errors.required">Please Select Currency</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="p-fluid p-col-12 d-flex flex-wrap">
                                    <div class="p-field p-col-3">
                                        <label for="price">Price <span class="mandatory-fields">*</span></label>
                                        <input formControlName="price" id="price" type="number" pInputText
                                            class="form-control" autocomplete="off"
                                            [ngClass]="{ 'is-invalid': submitted && f.price.errors }"
                                            placeholder="Enter price">
                                        <div *ngIf="submitted && f.price.errors" class="invalid-feedback">
                                            <div *ngIf="f.price.errors.required">Please enter price</div>
                                        </div>
                                    </div>
                                    <div class="p-field p-col-3">
                                        <label for="duration">Duration (in months) <span
                                                class="mandatory-fields">*</span></label>
                                        <input formControlName="duration" id="duration" type="number" pInputText
                                            class="form-control" autocomplete="off"
                                            [ngClass]="{ 'is-invalid': submitted && f.duration.errors }"
                                            placeholder="Enter duration">
                                        <div *ngIf="submitted && f.duration.errors" class="invalid-feedback">
                                            <div *ngIf="f.duration.errors.required">Please enter duration</div>
                                        </div>
                                    </div>
                                    <div class="p-field p-col-3">
                                        <label for="discountPrice">Discount Price <span
                                                class="mandatory-fields">*</span></label>
                                        <input formControlName="discountPrice" id="discountPrice" type="number"
                                            pInputText class="form-control" autocomplete="off"
                                            [ngClass]="{ 'is-invalid': submitted && f.discountPrice.errors }"
                                            placeholder="Enter discountPrice">
                                        <div *ngIf="submitted && f.discountPrice.errors" class="invalid-feedback">
                                            <div *ngIf="f.discountPrice.errors.required">Please enter discount price
                                            </div>
                                        </div>
                                    </div>
                                    <div class="p-field p-col-2 statusdivMain">
                                        <label for="status">Status </label>
                                        <p-inputSwitch class="checkbox-mt-10 mx-2" formControlName="status"
                                            inputId="status"
                                            [ngClass]="{ 'is-invalid': submitted && f.status.errors }"></p-inputSwitch>
                                    </div>
                                    <div class="lineborderHR">
                                        <hr>
                                    </div>
                                    <div class="p-field p-col-12 benefitsMain">
                                        <div class="subTitleLable">
                                            <h4>Benefits</h4>
                                        </div>
                                        <div formArrayName="benefit">
                                            <div *ngFor="let benefit of benefitsFormArray.controls; let i=index;"
                                                class="benefitList">
                                                <ul [formGroupName]="i">
                                                    <li>
                                                        <div class="  p-col">
                                                            <input id="key" formControlName="key" type="text" pInputText
                                                                autocomplete="off"
                                                                [ngClass]="{ 'is-invalid': submitted && g(i).key.errors }">
                                                            <div *ngIf="((submitted && g(i).key.errors) || (g(i).key.errors && (g(i).key.dirty || g(i).key.touched)))"
                                                                class="invalid-feedback">
                                                                <div *ngIf="g(i).key.errors.required">Key is required
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="  p-col">
                                                            <input id="value" formControlName="value" type="text"
                                                                pInputText autocomplete="off"
                                                                [ngClass]="{ 'is-invalid': submitted && g(i).value.errors }">
                                                            <div *ngIf="((submitted && g(i).value.errors) || (g(i).value.errors && (g(i).value.dirty || g(i).value.touched)))"
                                                                class="invalid-feedback">
                                                                <div *ngIf="g(i).value.errors.required">Value is
                                                                    required
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="plusActionBtn">
                                                            <button pButton pRipple type="button" (click)="addBenefit()"
                                                                *ngIf="((this.benefitsFormArray.length - 1) === i)"
                                                                icon="pi pi-plus"
                                                                class="p-button-success   p-button-rounded"></button>
                                                            <button pButton pRipple type="button"
                                                                (click)="removeBenefit(i)"
                                                                *ngIf="((this.benefitsFormArray.length - 1) !== i)"
                                                                icon="pi pi-trash"
                                                                class="p-button-danger   p-button-rounded"></button>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>


                            <div class="button-set p-col-12 d-flex p-fluid p-jc-md-end bottom-footer mt-2 mb-5">
                                <div class="p-formgrid p-grid">
                                    <p-toast></p-toast>
                                    <button type="text" (click)="onSubmit()" pButton icon="pi pi-check" label="Save"
                                        class="p-button-success save-btn p-mr-3" style="width: auto"></button>
                                    <button type="text" (click)="backLink()" pButton icon="pi pi-times" label="Cancel"
                                        class="p-button-danger cancel-btn" style="width: auto"></button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>